import ClassNameBuilder from '../../tools/ClassNameBuilder'
import { Row } from '../common/pure/FlexContainer'

interface FlowCardStepIndicatorProps {
    steps: number
    current: number
}
export default function FlowCardStepIndicator({ steps, current }: FlowCardStepIndicatorProps) {
    const getDotClassNames = (index: number) =>
        new ClassNameBuilder()
            .add('flow-card-step-indicator__dot')
            .addIf('selected', current === index)
    return (
        <Row
            grow
            gap={0.5}
            arrangement="center"
            alignment="center"
            className="flow-card-step-indicator"
        >
            {new Array(steps).fill(0).map((_, i) => (
                <div key={i} className={getDotClassNames(i).toString()} />
            ))}
        </Row>
    )
}
